/**
 *  Trabalha hash para redirecionar a tab sem correr a página
 */
function init(hashId) {
    $('a', hashId).on('shown.bs.tab', function (event) {
        window.location.hash = $(event.target).attr('href').replace(/-/, "_");
    });
    if (window.location.hash) {
        let hash = window.location.hash.replace(/_/, "-")
        if (!hash.includes("#")) {
            hash = "#" + hash
        }
        $(`a[href="${hash}"]`).trigger('click');
    }
     
}

module.exports = {
    init
}




// WEBPACK FOOTER //
// ./resources/assets/layout-novo/js/modulo/tab-hash.js